import React, { useEffect, createElement } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LeadSection } from '../components/LeadSection';
import { SymptomSection } from '../components/SymptomSection';
import { FuturePacingSection } from '../components/FuturePacingSection';
import { MechanismSection } from '../components/MechanismSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { MainIngredientSection } from '../components/MainIngredientSection';
import { ProductRevealSection } from '../components/ProductRevealSection';
export function Advertorial() {
  useEffect(() => {
    // Taboola Pixel
    ;
    (window as any)._tfa = (window as any)._tfa || [];
    (window as any)._tfa.push({
      notify: 'event',
      name: 'page_view',
      id: 2020143
    });
    if (!document.getElementById('tb_tfa_script')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = '//cdn.taboola.com/libtrc/unip/2020143/tfa.js';
      script.id = 'tb_tfa_script';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    // Google Analytics (gtag.js)
    if (!document.getElementById('ga_gtag_script')) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-TEW0MBTC4Q';
      gtagScript.id = 'ga_gtag_script';
      document.head.appendChild(gtagScript);
    }
    ;
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      ;
      (window as any).dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', 'G-TEW0MBTC4Q');
    // Taboola Click ID (tblci) passthrough to CTA links
    const urlParams = new URLSearchParams(window.location.search);
    const tblci = urlParams.get('tblci');
    if (tblci) {
      document.querySelectorAll('a[href*="tryclearguard.com"]').forEach(link => {
        const url = new URL((link as HTMLAnchorElement).href);
        url.searchParams.set('tblci', tblci);
        (link as HTMLAnchorElement).href = url.toString();
      });
    }
  }, []);
  return <div className="min-h-screen flex flex-col bg-stone-50" data-id="element-525">
      <Header data-id="element-526" />

      <main className="flex-grow px-4 md:px-6" data-id="element-527">
        <article className="pb-8" data-id="element-528">
          <LeadSection data-id="element-529" />
          <SymptomSection data-id="element-530" />
          <FuturePacingSection data-id="element-531" />
          <MechanismSection data-id="element-532" />
          <TestimonialSection data-id="element-533" />
          <MainIngredientSection data-id="element-534" />
          <ProductRevealSection data-id="element-535" />
        </article>
      </main>

      <Footer data-id="element-536" />
    </div>;
}